import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./CurrentlyWorking.css";

function CurrentlyWorking() {
  const es_en = useSelector((state) => state.translation);

  const currentProjects = [
    {
      id: 1,
      name: "GameOn",
      status: es_en ? "In Progress" : "En Progreso",
      progress: 75,
      description: es_en
        ? "Social sports application designed to connect people through sport, organise activities, and improve community interaction around shared interests."
        : "Aplicación deportiva social pensada para conectar personas a través del deporte, organizar actividades y mejorar la interacción de la comunidad en torno a intereses compartidos.",
      tech: ["Angular", "Node.js", "PostgreSQL", "TypeScript"],
    },
    {
      id: 2,
      name: "NutriApp",
      status: es_en ? "In Progress" : "En Progreso",
      progress: 60,
      description: es_en
        ? "Meal and stock management app focused on generating monthly menus based on available ingredients, helping optimise planning and reduce waste."
        : "Gestor de comidas y stock orientado a generar menús mensuales según los ingredientes disponibles, ayudando a optimizar la planificación y reducir desperdicios.",
      tech: ["Angular", "NestJS", "PostgreSQL", "Docker"],
    },
    {
      id: 3,
      name: "Orion OS",
      status: es_en ? "In Progress" : "En Progreso",
      progress: 80,
      progressLabel: es_en ? "Never ends" : "Nunca termina",
      description: es_en
        ? "AI agent orchestration framework designed for a single developer to operate with the capacity of a team. Built with memory, specialised roles and Github MCP."
        : "Framework de orquestación de agentes IA diseñado para que un solo desarrollador opere con la capacidad de un equipo. Con memoria, roles especializados y Github MCP.",
      tech: ["AI Agents", "Github MCP", "Claude", "Orion OS"],
      link: "/orion-os",
    },
  ];

  return (
    <section className="currently-working section" id="currently-working">
      <div className="container">
        <h2 className="section__title reveal">
          {es_en ? "Currently Working On" : "Actualmente Trabajando En"}
        </h2>
        <p className="section__subtitle reveal">
          {es_en
            ? "Active projects and ongoing development"
            : "Proyectos activos y desarrollo en curso"}
        </p>

        <div className="currently-working__grid">
          {currentProjects.map((project) => (
            <div key={project.id} className="currently-working__card reveal">
              <div className="currently-working__header">
                <h3 className="currently-working__name">{project.name}</h3>
                <span
                  className={`currently-working__status ${
                    project.status === (es_en ? "In Progress" : "En Progreso")
                      ? "currently-working__status--active"
                      : "currently-working__status--planning"
                  }`}
                >
                  {project.status}
                </span>
              </div>

              <p className="currently-working__description">
                {project.description}
              </p>

              <div className="currently-working__progress">
                <div className="currently-working__progress-bar">
                  <div
                    className="currently-working__progress-fill"
                    style={{ width: `${project.progress}%` }}
                  ></div>
                </div>
                <span className="currently-working__progress-text">
                  {project.progressLabel || `${project.progress}%`}
                </span>
              </div>

              <div className="currently-working__tech">
                {project.tech.map((tech, idx) => (
                  <span key={idx} className="currently-working__tech-tag">
                    {tech}
                  </span>
                ))}
              </div>

              {project.link && (
                <div className="currently-working__link-container">
                  <Link to={project.link} className="currently-working__link">
                    {es_en ? "View Project" : "Ver proyecto"}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CurrentlyWorking;
